// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"FileUploader_fileInput__46iE0","label":"FileUploader_label__1oABX"};